export const FindAStore: React.FC = () => {
	const handleClick = (e: React.MouseEvent) => {
		e.preventDefault();

		const img = new Image();
		img.src =
			'https://insight.adsrvr.org/track/pxl/?adv=xwyhvtq&ct=0:8d3ogb7&fmt=3';

		// Navigate after short delay
		setTimeout(() => {
			window.location.href = 'https://www.biggby.com/locations/';
		}, 200);
	};

	return (
		<a
			className="text-white header-find-a-store"
			href="https://www.biggby.com/locations/"
			onClick={e => handleClick(e)}
		>
			<div className="d-flex w-100 h-100 align-items-center">
				Find a Store
			</div>
		</a>
	);
};
